import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payroll-finalize',
  templateUrl: './payroll-finalize.component.html',
  styleUrls: ['./payroll-finalize.component.css']
})
export class PayrollFinalizeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/payroll/payroll-finalize/payroll-finalize.component.ts